import React from 'react';
import { Settings } from 'react-slick';
import { IAgent, ITestimonial } from '../../lib';
import { Carousel } from '../Carousel';
import Heading from './Heading';
import { Button } from '../Button/Button';

export interface ITestimonialsProp {
  className?: string;
  title?: string;
  titleHeadingLevel?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p";
  headingClass?: string;
  leftColumn: React.ReactNode;
  columnsWrapperClass?: string;
  leftColumnClass?: string;
  dividerClass?: string;
  rightColumnClass?: string;
  testimonials?: ITestimonial[];
  testimonialTextClass?: string;
  showAttribution: boolean;
  attributionClass?: string;
  showQuotes?: boolean;
  slickSettings?: Settings;
}

export const Testimonials: React.FC<ITestimonialsProp> = ({
  className = "",
  title,
  titleHeadingLevel,
  headingClass,
  leftColumn,
  columnsWrapperClass,
  leftColumnClass,
  dividerClass,
  rightColumnClass,
  testimonials,
  testimonialTextClass = "",
  showAttribution,
  attributionClass = "",
  showQuotes = true,
  slickSettings = {
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          arrows: false
        }
      }
    ]
  },
}) => {

  let layoutClasses = {
    headingClass: "pb-5 text-2xl font-bold",
    columnsWrapperClass: "w-full flex flex-col md:flex-row items-center",
    leftColumnClass: "w-full md:w-1/3 pb-6 md:pb-0 md:pr-6 lg:pr-28 flex justify-center md:justify-end flex-wrap",
    dividerClass: "border-b w-full md:w-px md:border-b-0 md:border-l md:self-stretch",
    rightColumnClass: "w-full md:w-2/3 pt-6 md:pt-0 md:pl-6 lg:pl-28",
  }

  if (columnsWrapperClass)
    layoutClasses.columnsWrapperClass = columnsWrapperClass

  if (leftColumnClass)
    layoutClasses.leftColumnClass = leftColumnClass

  if (dividerClass)
    layoutClasses.dividerClass = dividerClass

  if (rightColumnClass)
    layoutClasses.rightColumnClass = rightColumnClass

  if (headingClass)
    layoutClasses.headingClass = headingClass

  return (
    <>
      {testimonials && testimonials.length > 0 &&
        <section className={`testimonials py-20 px-2 md:px-14 ${className}`}>
          {title && (
            <Heading
              headingLevel={titleHeadingLevel || "h3"}
              className={headingClass}
            >
              {title}
            </Heading>
          )}
          <div className={layoutClasses.columnsWrapperClass}>
            <div className={layoutClasses.leftColumnClass}>
              {leftColumn}
            </div>
            <div className={layoutClasses.dividerClass}></div>
            <div className={layoutClasses.rightColumnClass}>
              <Carousel
                className="w-full"
                slickSettings={slickSettings}
              >
                {testimonials.map((item, index) => (
                  <div key={index}>
                    <div className="flex flex-row w-full">
                      {showQuotes && <div className="self-start text-8xl">&#8220;</div>}
                      <div className={`p-2 whitespace-pre-line ${testimonialTextClass}`}>{item.text}</div>
                      {showQuotes && <div className="self-end text-8xl leading-[0]">&#8221;</div>}
                    </div>
                    {showAttribution && item.attribution &&
                      <div className={`italic text-center pt-1 font-bold ${attributionClass}`}>
                        {item.attribution}
                      </div>
                    }
                  </div>
                ))}
              </Carousel>
            </div>
          </div>
        </section>
      }
    </>
  );
}

export default Testimonials;